/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Request to generate an audience which can be used to serve advertisements
*/
export class V1AdditionalArguments {
    /**
    * (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
    */
    'queryId'?: string;
    /**
    * (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
    */
    'seenCount'?: number;
    /**
    * (OPTIONAL) Additional field you might need in order to run a job. The only one that uses this currently is the enrichment job.
    */
    'locType'?: string;
    /**
    * (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
    */
    'radius'?: number;
    /**
    * (OPTIONAL) Additional field you might need in order to run a job. The only one that could use this currently is the digital canvassing job.
    */
    'queryType'?: string;
    /**
    * (OPTIONAL) Additional field you might need in order to run a job.
    */
    'queryArgs'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "queryId",
            "baseName": "query_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "seenCount",
            "baseName": "seen_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "locType",
            "baseName": "loc_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "radius",
            "baseName": "radius",
            "type": "number",
            "format": "double"
        },
        {
            "name": "queryType",
            "baseName": "query_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "queryArgs",
            "baseName": "query_args",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1AdditionalArguments.attributeTypeMap;
    }

    public constructor() {
    }
}

